module.exports = __webpack_public_path__ + "static/media/carousel_2.d086bc71.jpg";